module.exports = __webpack_public_path__ + "c2d070366f606dfa2078a50b40c9d55f.png";